/**
 * Google Analytics Helper Utilities
 * Provides helper functions for tracking GA events via GTM dataLayer
 */

/**
 * Check if dataLayer is available (GTM loaded)
 */
const isDataLayerAvailable = (): boolean => {
  return typeof window !== 'undefined' && !!(window as any).dataLayer;
};

/**
 * Push event to Google Analytics via GTM dataLayer
 * @param eventName - Name of the GA event
 * @param eventParams - Optional event parameters
 */
export const pushGAEvent = (eventName: string, eventParams?: Record<string, any>): void => {
  if (isDataLayerAvailable()) {
    try {
      const eventData: any = {
        event: eventName,
        ...(eventParams || {})
      };
      
      (window as any).dataLayer.push(eventData);
      console.log('[GA] Event tracked:', eventName, eventParams || '');
    } catch (error) {
      console.error('[GA] Error tracking event:', error);
    }
  } else {
    console.warn('[GA] dataLayer not available, event not tracked:', eventName);
  }
};

/**
 * GA Event Names
 */
export const GA_EVENTS = {
  START_FREE_TRIAL_CLICK: 'start_free_trial_click',
  OTP_SUCCESS: 'otp_success',
  PAYMENT_GATEWAY_INITIATED: 'payment_gateway_initiated',
  TRIAL_PAYMENT_SUCCESS: 'trial_payment_success',
  SUBSCRIPTION_PAYMENT_SUCCESS: 'subscription_payment_success',
};

